import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router';
import { isBranch, isLocalViewer } from '../../../utils/locationUtils';
import { LoggerFactory } from '../../LoggerFactory';

interface ILoggerContext {
  logger: LoggerFactory;
}

export const LoggerContext = createContext<ILoggerContext>({
  logger: new LoggerFactory(),
});

export const LoggerConsumer = LoggerContext.Consumer;

export const LoggerProvider = ({ children, artifactId }) => {
  const location = useLocation();
  const loggerFactory = new LoggerFactory(
    isLocalViewer(location),
    isBranch(location),
    artifactId,
  );

  return (
    <LoggerContext.Provider value={{ logger: loggerFactory }}>
      {children}
    </LoggerContext.Provider>
  );
};

export function useLogger() {
  const loggerContext = useContext(LoggerContext);
  return loggerContext;
}

export const withLogger = (Component: any) => {
  return function WithLogger(props) {
    const wrappedComponentName =
      Component.displayName || Component.name || 'UnknownComponent';
    Component.displayName = wrappedComponentName;
    return (
      <LoggerConsumer>
        {({ logger }) => {
          return <Component logger={logger} {...props} />;
        }}
      </LoggerConsumer>
    );
  };
};
